
import { Action } from '@ngrx/store';
import { dcmusuario } from 'src/app/models/SicarMap/dcmusuario.model';


export const MENU_VISIBLE = '[MENU] Visible';
export const MENU_HIDDEN = '[MENU] Hidden';

export class MenuVisibleAction implements Action {
  readonly type = MENU_VISIBLE;
  constructor() {}
}
export class MenuHiddenAction implements Action {
  readonly type = MENU_HIDDEN;
  constructor() {
  }
}

export type MenuActions =
  | MenuVisibleAction
  | MenuHiddenAction;
